import React from "react";
import View from "views";
import { useDispatch, useSelector } from "react-redux";
import { HiX } from "react-icons/hi";
import { t } from "i18next";
import { setVarta } from "store/base/commonSlice";
import CustomerMobileHeader from "./CustomerMobileHeader";
import CustomerMobileBottomNav from "./CustomerMobileBottomNav";
import { CustomerMobileShellProvider } from "contexts/CustomerMobileShellContext";
import { CUSTOMER_MOBILE_SCROLL_BOTTOM_PADDING_CLASS } from "constants/theme.constant";
import XiaomiAddressBanner from "components/vendors/Xiaomi/XiaomiAddressBanner";
import InciAkuSeedTrackBanner from "components/vendors/InciAku/InciAkuSeedTrackBanner";

const CustomerMobileLayout = (props) => {
  const dispatch = useDispatch();
  const userStatus = useSelector((state) => state.auth.user?.status);
  const varta = useSelector((state) => state.base.common.varta);

  const handleCloseVarta = () => {
    // setVarta reducer'ı zaten güvenli şekilde localStorage'a yazıyor.
    dispatch(
      setVarta({
        active: true,
        showwarning: false,
      })
    );
  };

  return (
    <CustomerMobileShellProvider>
      <div className="flex flex-auto flex-col min-h-screen min-w-0 bg-[#F6F7F4] dark:bg-gray-950">
        <CustomerMobileHeader />
        {varta?.active && (
          <>
            <div className="w-full text-xs bg-[#007D72] text-white p-1.5">
              PTT Kargo Kodu: <b>204607036</b>
            </div>
            {varta?.showwarning && (
              <div className="flex items-center justify-between gap-2.5 w-full text-xs bg-[#FF7C47] text-white p-1.5">
                *Atık pilleriniz PTT ile geri dönüşüm tesisine ulaştığı zaman
                hediye kartlarınız aktif olacaktır. Atık pilinizin güncel
                durumunu “Atıklarım” bölümünden görüntüleyebilirsiniz.
                <HiX
                  className="text-lg cursor-pointer shrink-0"
                  onClick={() => handleCloseVarta()}
                />
              </div>
            )}
          </>
        )}
        {userStatus === 0 && (
          <div className="w-full text-xs bg-[#FF7C47] text-white p-1.5">
            {t("auth.passiveWarning")}
          </div>
        )}
        <XiaomiAddressBanner />
        <InciAkuSeedTrackBanner />
        <div
          className={`flex flex-1 flex-col min-h-0 min-w-0 overflow-y-auto overflow-x-hidden ${CUSTOMER_MOBILE_SCROLL_BOTTOM_PADDING_CLASS}`}
        >
          <View {...props} />
        </div>
        <CustomerMobileBottomNav />
      </div>
    </CustomerMobileShellProvider>
  );
};

export default CustomerMobileLayout;
